'use client';

import { useEffect } from "react";

export default function SWRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!("serviceWorker" in navigator)) return;
    // '/sw.js' moet in /public staan
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // optioneel: logging
    });
  }, []);
  return null;
}
